import { render, staticRenderFns } from "./BDXStatusModalItem.vue?vue&type=template&id=5b61409d&scoped=true"
import script from "./BDXStatusModalItem.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalItem.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusModalItem.vue?vue&type=style&index=0&id=5b61409d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61409d",
  null
  
)

export default component.exports